// Post Falls Orthodontics (Post Falls ID) - single office. Sister brand to Curtis
// Orthodontics (same owner, separate domain postfallsortho.com). Backend:
// bondLocations.ts POST_FALLS (brandId "post_falls", catalog f1eee43f, Edge loc 2,
// procedure 208, DB 372). Native booking via ortho2-newpatient backend (WCF intake
// disabled). English-only.
import type { BrandConfig } from "./types";

export const postFalls: BrandConfig = {
  slug: "post-falls",
  brandId: "post_falls",
  brandName: "Post Falls Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/31241a1d-bc47-4f91-a041-a01ed4592e4d.png",
  phone: "(208) 777-0500",
  phoneHref: "tel:+12087770500",
  theme: { primary: "#00467F", primaryDark: "#022F52" }, // scoured 2026-07-20 postfallsortho.com (navy)
  locales: ["en"],
  locations: {
    POST_FALLS: {
      id: "POST_FALLS",
      name: "Post Falls",
      addressLines: ["602 N Calgary Ct, Ste 302", "Post Falls, ID 83854"],
      mapsUrl: "https://maps.google.com/?q=602+N+Calgary+Ct+Ste+302+Post+Falls+ID+83854",
      timezone: "America/Los_Angeles",
    },
  },
};
